<div class="stats h-full bg-white p-[15px] text-[#0f2744] shadow-sm">
  <div class="flex min-h-[32px] items-center justify-between pb-[5px]">
    <h2
      class="m-0 inline-flex items-center gap-2 font-montserrat text-base font-bold uppercase"
    >
      <span
        class="material-icons-outlined h-[20px] w-[20px] shrink-0 text-[20px] leading-[20px]"
        aria-hidden="true"
        >bar_chart</span
      >
      {{ data$()?.title }}
    </h2>
    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        class="opacity-60 transition-opacity duration-200 hover:opacity-80 [&_mat-icon]:text-[16px]"
        [attr.aria-label]="'Download ' + data$()?.title + ' data as Excel'"
        (click)="downloadXlsx()"
      >
        <mat-icon aria-hidden="true">file_open</mat-icon>
      </button>
      <button
        mat-icon-button
        class="opacity-60 transition-opacity duration-200 hover:opacity-80 [&_mat-icon]:text-[16px]"
        [attr.aria-label]="'Expand ' + data$()?.title + ' chart'"
        (click)="openModal()"
      >
        <mat-icon aria-hidden="true">fullscreen</mat-icon>
      </button>
    </div>
  </div>
  <div
    class="relative min-h-[180px] overflow-visible rounded-lg px-[15px] py-[7.5px] text-center text-2xl font-normal"
    [attr.aria-busy]="loading"
  >
    <div
      class="min-h-[165px] w-full"
      [ngClass]="{ 'opacity-20 blur-[0.1rem]': loading }"
      [style.height]="chartService$.recommendedHeight$() + 'px'"
    >
      <canvas
        baseChart
        role="img"
        [attr.aria-label]="'Bar chart: ' + data$()?.title"
        [type]="chartService$.barChartType"
        [data]="chartService$.barChartData$()"
        [options]="chartService$.barChartOptions"
        [plugins]="chartService$.barChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>
    </div>

    @if (loading) {
      <div
        class="absolute inset-0 m-auto flex items-center justify-center"
        role="status"
        aria-label="Loading chart"
      >
        <mat-spinner [diameter]="75" aria-hidden="true"></mat-spinner>
      </div>
    }
  </div>
</div>
